import { API_APP_PATH, API_PATH } from '@/shared/constants/api'
import { apiRequest } from '@/shared/helpers/api-request'
import { getJwt } from '@/shared/lib/betterAuth/get-jwt'
import type {
  OnboardingTrace,
  OnboardingTraceFilters,
  OnboardingValidation,
} from '@/shared/types/global.types'

export async function fetchOnboardingTrace(
  filters: OnboardingTraceFilters,
): Promise<OnboardingTrace | undefined> {
  const token = await getJwt()
  const params = new URLSearchParams({ product_type: filters.product_type })
  return apiRequest<OnboardingTrace | undefined>(
    `${API_APP_PATH.ONBOARDING}?${params.toString()}`,
    token,
    'GET',
    undefined,
    'app',
  )
}

export async function createOnboardingTrace(
  productType: OnboardingTrace['product_type'],
): Promise<OnboardingTrace> {
  const token = await getJwt()
  return apiRequest<OnboardingTrace>(
    API_APP_PATH.ONBOARDING,
    token,
    'POST',
    { product_type: productType },
    'app',
  )
}

export async function updateOnboardingTrace(
  id: string,
  body: Partial<Pick<OnboardingTrace, 'step' | 'status'>>,
): Promise<OnboardingTrace> {
  const token = await getJwt()
  return apiRequest<OnboardingTrace>(
    `${API_APP_PATH.ONBOARDING}/${id}`,
    token,
    'PATCH',
    body,
    'app',
  )
}

export async function validateOnboarding() {
  const token = await getJwt()
  return apiRequest<OnboardingValidation>(API_PATH.VALIDATE_ONBOARDING, token)
}
